import { platformApiFetch } from '@/services/platformApi/client';
import { ServiceProviderRow } from '@/types/supabase';

export async function fetchServiceProviderAdmin(id: string): Promise<ServiceProviderRow | null> {
  return platformApiFetch<ServiceProviderRow | null>(`/v1/providers/admin/${id}`);
}